import Svg from "@/components/Svg";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

export default function NutritionIcon({ size = 40, withCircle = true, color }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 40 40";
  const iconTransform = withCircle ? "" : "translate(-20 -20)";

  return (
    <Svg
      as="svg"
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={color} />}
      <g transform={iconTransform}>
        <path
          d="M45.7425 42.8415L41.5118 47.0721L53.6155 59.1758C54.1672 59.7275 54.8884 60.0033 55.6129 60.0033C56.3374 60.0033 57.0585 59.7275 57.6102 59.1758L57.8462 58.9398C58.9495 57.8365 58.9495 56.0485 57.8462 54.9452L45.7425 42.8415ZM56.1978 57.2915L55.9618 57.5274C55.8422 57.6471 55.7026 57.6736 55.6095 57.6736C55.5165 57.6736 55.3769 57.6471 55.2573 57.5274L44.7986 47.0688L45.7392 46.1283L56.1978 56.5869C56.3905 56.7797 56.3905 57.0987 56.1978 57.2915Z"
          fill={color}
        />
        <path
          d="M43.7428 42.0171L40.6879 45.072L42.0978 46.482L45.1528 43.427L43.7428 42.0171Z"
          fill={color}
        />
        <path
          d="M34.217 39.6942L38.6437 35.2675L37.2878 33.9116L28.6138 25.2343C26.6231 23.2436 25.5098 22.7517 24.8916 22.7517C24.2868 22.7517 24.1605 23.2237 24.1605 23.2237C24.1605 23.2237 21.9471 30.3091 34.217 39.6909V39.6942ZM26.5865 26.5105C26.7062 26.6235 26.8324 26.7497 26.9654 26.8794L35.3502 35.2675L34.0408 36.5769C29.5875 32.8415 27.7231 29.6942 26.9421 27.6338C26.7892 27.2316 26.6729 26.8561 26.5832 26.5105H26.5865Z"
          fill={color}
        />
        <path
          d="M55.3436 25.6098C55.9285 25.0249 56.1113 24.2605 55.7491 23.9016C55.3902 23.5427 54.6258 23.7255 54.0409 24.3071L45.4101 32.3596L43.5723 30.5218L51.6248 21.891C52.2097 21.3061 52.3925 20.5417 52.0302 20.1828C51.6713 19.8238 50.9069 20.0066 50.322 20.5882L41.6913 28.6407L41.6846 28.6341C39.9232 30.3955 39.7737 33.2303 41.103 35.6198L34.546 42.1768L33.9279 41.5586L21.8275 53.6657C20.7242 54.769 20.7242 56.557 21.8275 57.6603L22.0635 57.8963C22.6152 58.448 23.3363 58.7238 24.0608 58.7238C24.7853 58.7238 25.5065 58.448 26.0582 57.8963L38.1618 45.7926L37.5437 45.1745L44.0974 38.6208C45.1509 39.2057 46.2875 39.5048 47.3842 39.5048C48.7767 39.5048 50.0994 39.0229 51.0864 38.0359L47.2911 34.2406L55.3436 25.6098ZM24.4131 56.2512C24.2935 56.3709 24.1539 56.3975 24.0608 56.3975C23.9678 56.3975 23.8282 56.3709 23.7085 56.2512L23.4726 56.0153C23.2798 55.8225 23.2798 55.5035 23.4726 55.3107L33.9312 44.8521L34.8717 45.7926L24.4131 56.2512ZM44.0342 35.6896C43.2001 34.8554 42.7049 33.8152 42.5819 32.8248L46.9089 37.1519C45.882 37.0289 44.8584 36.5105 44.0342 35.6896Z"
          fill={color}
        />
        <path
          d="M59.5444 27.7002C59.1855 27.3413 58.4211 27.5241 57.8362 28.1057L49.2054 36.1582L51.0865 38.0392L59.139 29.4084C59.7239 28.8235 59.9067 28.0592 59.5444 27.7002Z"
          fill={color}
        />
      </g>
    </Svg>
  );
}
